import { render, staticRenderFns } from "./smartControlWarnLog_page.vue?vue&type=template&id=70679234&scoped=true"
import script from "./smartControlWarnLog_page.vue?vue&type=script&lang=js"
export * from "./smartControlWarnLog_page.vue?vue&type=script&lang=js"
import style0 from "./smartControlWarnLog_page.vue?vue&type=style&index=0&id=70679234&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70679234",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70679234')) {
      api.createRecord('70679234', component.options)
    } else {
      api.reload('70679234', component.options)
    }
    module.hot.accept("./smartControlWarnLog_page.vue?vue&type=template&id=70679234&scoped=true", function () {
      api.rerender('70679234', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/iot/smartControl/smartControlWarnLog_page.vue"
export default component.exports